import React from 'react';

export interface IconArrowDownProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconArrowDown: React.FC<IconArrowDownProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M12.75 4V3.25H11.25V4V18.4395L5.78021 12.9697L5.24988 12.4393L4.18922 13.5L4.71955 14.0303L11.4696 20.7803L11.9999 21.3107L12.5302 20.7803L19.2802 14.0303L19.8105 13.5L18.7499 12.4393L18.2196 12.9697L12.75 18.4392V4Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconArrowDown;
